var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-header"},[_c('h3',[_vm._v(_vm._s(_setup.title))]),_c('div',[_c('ul',_vm._l((_setup.list),function(item,index){return _c('li',{key:index},[_c('label',[_vm._v(_vm._s(item.title)+"：")]),_c('span',[_vm._v(_vm._s(item.value))])])}),0),_c('div',{staticClass:"option"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }